<template>
  <v-container id="init-home-container" class="mt-0 py-0 d-flex">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <v-row>
      <v-col cols="12" class="pt-0">
        <!-- <v-spacer></v-spacer> -->
        <titlecard></titlecard>
        <v-spacer></v-spacer>
        <frontdeskcards></frontdeskcards>
        <!-- <v-spacer></v-spacer> -->

        <!-- Expansion Panels -->
        <v-card elevation="2" tile class="resources pt-lg-4 pb-12">
          <v-row id="resources">
            <v-col cols="12" class="d-flex justify-center pa-0">
              <div
                id="contains-expansions-layout"
                class="d-flex justify-center"
              >
                <v-expansion-panels id="all-panels" accordion :value="0">
                  <h1>Resources</h1>
                  <resources></resources>
                </v-expansion-panels>
              </div>
            </v-col>
          </v-row>
        </v-card>

        <v-spacer></v-spacer>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #init-home-container {
    max-width: 1025px;
  }
  #home-container {
    height: auto;
  }

  #all-panels {
    width: 97%;
  }

  #resources {
    width: 97%;
    margin: 0 auto;
  }

  .resources {
    margin: 0 auto;
    margin-right: 4px;
    margin-left: 4px;
  }

  .theme--light.v-expansion-panels .v-expansion-panel {
    color: white;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  #all-panels {
    width: 95%;
  }

  .resources {
    margin: 0 auto;
    margin-right: 16px;
    margin-left: 16px;
  }
}

#contains-expansions-layout {
  width: 100%;
}

/* 1025 media q */
@media (min-width: 1025px) {
  #init-home-container {
    width: 70%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import titlecard from "../components/titlecard";
import frontdeskcards from "../components/frontdeskcards";
const resources = () => import("./resources.vue");

export default {
  name: "Home",
  components: {
    titlecard,
    frontdeskcards,
    resources,
  },
  mixins: [bus_common],
  data() {
    return {};
  },
  watch: {},
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init(self) {
      this.show_loader(false);
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
